import UserJson, { validateUserJson } from './UserJson';
import LocationJson, { validateLocationJson } from './LocationJson';
import MaterialItemJson, { validateMaterialItemJson } from './MaterialItemJson';
import RentalBookingJson, { validateRentalBookingJson } from './RentalBookingJson';
import { Validation } from './Validation';

/**
 * Termin von einem Event
 */
export default interface EventDateJson {
   title: string,

   beginDateTime: string,

   endDateTime: string,

   remarks: string,

   location: LocationJson | null,

   staffIds: number[] | null,

   materialItems: MaterialItemJson[] | null,

   materialRentalBookings: RentalBookingJson[] | null,
}

export type EventDateDesiredJson = Pick<EventDateJson, "beginDateTime" | "endDateTime" | "remarks">;

export function defaultEventDateJson(): EventDateJson {
   return {
      title: "",
      beginDateTime: "",
      endDateTime: "",
      remarks: "",
      location: null,
      staffIds: null,
      materialItems: null,
      materialRentalBookings: null,
   };
}

export function defaultEventDateDesiredJson(): EventDateDesiredJson {
   return {
      beginDateTime: "",
      endDateTime: "",
      remarks: "",
   };
}


export function validateEventDateJson(item: EventDateJson) {
   return new Validation(item)
      .validateString("title", 100)
      .validateDate("beginDateTime")
      .validateDateLater("endDateTime", "beginDateTime")
      .validateString("remarks", 500)
      .validateUsingFunction("location", validateLocationJson, true)
      .validateAllUsingFunction("materialItems", validateMaterialItemJson, 0, true)
      .validateAllUsingFunction("materialRentalBookings", validateRentalBookingJson, 0, true)
      .finish();
}

export function validateEventDateDesiredJson(item: EventDateJson) {
   return new Validation(item)
      .validateDate("beginDateTime")
      .validateDateLater("endDateTime", "beginDateTime")
      .validateString("remarks", 500)
      .finish();
}